/**
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2025-01-03 17:08:17
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2025-01-07 11:00:39
 * @FilePath: src/router/index.js
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
/**
* @Author 22030124/xieyq
* @Date 2023-11-15 14:33:03
* @Description 路由js
*/
import Vue from 'vue'
import Router from 'vue-router'
// 路由配置js
import routes from './constantRoutes.js'

Vue.use(Router)

// 创建路由
const createRouter = (routes) => {
  return new Router({
    mode: 'history',
    // 👇 __MICRO_APP_BASE_ROUTE__ 为micro-app传入的基础路由
    base: window.__MICRO_APP_BASE_ROUTE__ || process.env.BASE_URL,
    routes
  })
}

export default createRouter(routes)
